import { render, staticRenderFns } from "./AvailableRoomCard.vue?vue&type=template&id=c19b3f32&"
import script from "./AvailableRoomCard.vue?vue&type=script&lang=js&"
export * from "./AvailableRoomCard.vue?vue&type=script&lang=js&"
import style0 from "./AvailableRoomCard.vue?vue&type=style&index=0&id=c19b3f32&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports